<!-- 铁运入库月计划（合同拆分月计划） -->
<template>
  <div class="nx-list-page">
    <avue-crud
      ref="crud"
      v-model="form"
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      :search.sync="query"
      :defaults.sync="defaults"
      @search-change="searchChange"
      @search-reset="searchReset"
      @refresh-change="refreshChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      @on-load="onLoad"
      @selection-change="selectionChange"
    >
      <template slot="menuLeft">
        <el-button type="primary" size="small" plain icon="el-icon-download" :loading="exportLoading" @click="handleExport">导出</el-button>
      </template>
      <template slot-scope="{ row }" slot="intervalDate">
        <p>计划开始时间:{{ row.intervalStartTime }}</p>
        <p>计划结束时间:{{ row.intervalEndTime }}</p>
      </template>
      <template slot-scope="{ row }" slot="contractDate">
        <p>合同开始时间:{{ row.contractStartTime }}</p>
        <p>合同结束时间:{{ row.contractEndTime }}</p>
      </template>
      <template slot-scope="{ row }" slot="planMonthLabel">
        {{ formatPlanMonth(row) }}
      </template>
      <template #menu="{ row }">
        <el-button type="text" size="small" @click="openEditWeight(row)">编辑计划量</el-button>
      </template>
    </avue-crud>
    <el-dialog
      title="编辑计划量"
      :visible.sync="editDialogVisible"
      width="420px"
      append-to-body
      @closed="editForm = { id: null, planTotalWeight: null }"
    >
      <div v-if="editRowSnapshot" class="edit-hint">
        <p>合同：{{ editRowSnapshot.contractName || editRowSnapshot.contractNo || "-" }}</p>
        <p>计划月份：{{ formatPlanMonth(editRowSnapshot) }}</p>
        <p>已执行量(吨)：{{ editRowSnapshot.planExecuteWeight != null ? editRowSnapshot.planExecuteWeight : 0 }}</p>
        <p class="tip">保存后，同年计划下后续月份计划量将按比例自动调整。</p>
      </div>
      <el-form label-width="100px">
        <el-form-item label="计划量(吨)" required>
          <el-input-number
            v-model="editForm.planTotalWeight"
            :min="0.01"
            :max="99999999"
            :precision="PLAN_WEIGHT_PRECISION"
            :step="0.01"
            controls-position="right"
            style="width: 100%"
          />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="editDialogVisible = false">取 消</el-button>
        <el-button type="primary" :loading="editSaving" @click="submitEditWeight">保 存</el-button>
      </span>
    </el-dialog>
    <select-contract ref="selectContract" businessType="1" @replace="replace" />
  </div>
</template>

<script>
import crudMixins from "@/mixins/crud-mixins";
import { getList, updateRailContractMonthWeight, exportExcel } from "./api";
import { getSearchTimeConfig } from "@/basic-common/util/common";
import { downloadXls } from '@/util/util'
import SelectContract from "./components/select-contract.vue";

function buildCurrentMonthRange() {
  const now = new Date();
  const y = now.getFullYear();
  const m = now.getMonth() + 1;
  const pad = (n) => (n < 10 ? "0" : "") + n;
  const lastDay = new Date(y, m, 0).getDate();
  return [`${y}-${pad(m)}-01 00:00:00`, `${y}-${pad(m)}-${pad(lastDay)} 23:59:59`];
}

const CURRENT_MONTH_SEARCH_RANGE = buildCurrentMonthRange();
const PLAN_WEIGHT_PRECISION = 3;

export default {
  name: "RailwayTransportPlanMonthly",
  components: {
    SelectContract,
  },
  mixins: [crudMixins],
  data() {
    return {
      form: {},
      editDialogVisible: false,
      editSaving: false,
      exportLoading: false,
      editRowSnapshot: null,
      editForm: { id: null, planTotalWeight: null },
      PLAN_WEIGHT_PRECISION,
      apiConfig: {
        getList,
        remove: () => Promise.resolve(),
      },
      defaultParams: {
        planType: 1,
        businessType: 1,
        orderByIntervalStartAsc: 1,
        extPlanIdNotNull: 1,
      },
      option: {
        ...this.$store.state.publicOption,
        addBtn: false,
        editBtn: false,
        delBtn: false,
        viewBtn: false,
        menuWidth: 120,
        column: [
          {
            label: "计划月份",
            prop: "planMonthLabel",
            slot: true,
            width: 110,
            search: false,
          },
          {
            label: "计划编号",
            prop: "planNo",
            overHidden: true,
            minWidth: 150,
          },
          {
            label: "计划名称",
            prop: "planName",
            overHidden: true,
            minWidth: 150,
            search: true,
            maxlength: 30,
          },
          {
            label: "合同名称",
            prop: "contractName",
            search: true,
            overHidden: true,
            width: 150,
            type: "input",
            remote: true,
            readonly: true,
            maxlength: 30,
            click: () => {
              const { dialogForm } = this.$refs.crud.$refs;
              if (dialogForm && dialogForm.boxVisible) {
                this.$refs.selectContract.open("1");
              }
            },
          },
          {
            label: "客户",
            prop: "custNo",
            overHidden: true,
            width: 150,
            search: true,
            type: "select",
            remote: true,
            dicUrl: "/api/produce/blade-dept/select/distinct/select",
            props: {
              label: "deptName",
              value: "id",
            },
            formatter: (row) => row.custName || row.custNo || "-",
          },
          {
            label: "物资名称",
            prop: "cargoNo",
            search: true,
            overHidden: true,
            width: 150,
            type: "select",
            remote: true,
            dicUrl: "/api/produce/vardict/select/distinct/pycode?varName={{key}}",
            props: {
              label: "varName",
              value: "varNo",
            },
            formatter: (row) => row.cargoName || row.cargoNo || "-",
          },
          {
            label: "计划量(吨)",
            prop: "planTotalWeight",
            type: "number",
            precision: PLAN_WEIGHT_PRECISION,
            min: 0.01,
            max: 99999,
            overHidden: true,
            minWidth: 120,
          },
          {
            label: "执行量(吨)",
            prop: "planExecuteWeight",
            width: 110,
          },
          {
            label: "计划时间",
            prop: "intervalDate",
            slot: true,
            overHidden: true,
            width: 320,
            addDisplay: false,
            editDisplay: false,
            viewDisplay: false,
          },
          {
            label: "合同起止时间",
            prop: "contractDate",
            slot: true,
            minWidth: 320,
            overHidden: true,
            addDisplay: false,
            editDisplay: false,
            viewDisplay: false,
          },
          {
            ...getSearchTimeConfig(CURRENT_MONTH_SEARCH_RANGE, { type: "month", label: "计划月份" }),
            paramsKey: ["startTime", "endTime"],
          },
        ],
      },
    };
  },
  methods: {
    formatPlanMonth(row) {
      if (!row || !row.intervalStartTime) {
        return "-";
      }
      const s = String(row.intervalStartTime);
      const m = s.match(/^(\d{4}-\d{2})/);
      return m ? m[1] : s.slice(0, 7);
    },
    replace(row) {
      const replaceKey = [
        "id",
        "custNo",
        "contractEndTime",
        "contractStartTime",
        "cargoName",
        "cargoNo",
        "contractName",
        "contractNo",
      ];
      replaceKey.forEach((item) => {
        if (item !== "id") {
          this.$set(this.form, item, row[item]);
        } else {
          this.$set(this.form, "contractExtId", row.id);
        }
      });
    },
    openEditWeight(row) {
      this.editRowSnapshot = { ...row };
      this.editForm = {
        id: row.id,
        planTotalWeight:
          row.planTotalWeight != null ? Number(row.planTotalWeight) : null,
      };
      this.editDialogVisible = true;
    },
    submitEditWeight() {
      const id = this.editForm.id;
      const w = this.editForm.planTotalWeight;
      if (id == null || w == null || w <= 0) {
        this.$message.warning("请填写有效的计划量");
        return;
      }
      const exec = Number(this.editRowSnapshot.planExecuteWeight || 0);
      if (w < exec) {
        this.$message.warning("计划量不能小于已执行量");
        return;
      }
      this.editSaving = true;
      updateRailContractMonthWeight(id, w)
        .then(() => {
          this.$message.success("保存成功");
          this.editDialogVisible = false;
          this.onLoad(this.page, this.query);
        })
        .catch((e) => {
          const msg =
            (e && e.response && e.response.data && e.response.data.msg) ||
            (e && e.message) ||
            "保存失败";
          this.$message.error(msg);
        })
        .finally(() => {
          this.editSaving = false;
        });
    },
    async handleExport() {
      if ((this.page.total || 0) < 1) {
        this.$message.warning("无数据可导出");
        return;
      }
      this.exportLoading = true;
      try {
        const params = this.formatParams(Object.assign({}, this.defaultParams, this.query));
        const res = await exportExcel(params);
        downloadXls(res.data, `铁路入库月计划_${Date.now()}.xlsx`);
        if (this.page.total > 10000) {
          this.$message.warning(`仅导出前 10000 条，共 ${this.page.total} 条`);
        } else {
          this.$message.success("导出成功");
        }
      } catch (e) {
        this.$message.error("导出失败");
      } finally {
        this.exportLoading = false;
      }
    },
  },
};
</script>

<style scoped lang="scss">
p {
  margin: 0;
}
.edit-hint {
  font-size: 13px;
  color: #475569;
  margin-bottom: 16px;
  line-height: 1.6;
  .tip {
    margin-top: 8px;
    color: #64748b;
    font-size: 12px;
  }
}
</style>
